import { Fragment, FunctionComponent } from 'react'
import { Icon, IconType } from '../../../../components'
import LOGO from '../../../../assets/logo/lancape_no_bg.png'
import { Menu, Transition } from '@headlessui/react'
import classNames from 'classnames'
import { Brand } from '../../../../gql/types'
import { useLogout } from '../../../../hooks'
import { Avatar } from '../../../../elements'

interface IDefaultProps {}

interface IProps extends Partial<IDefaultProps> {
  brand: Brand
  timeLeft: string
  title: string
  description?: string
}

const defaultProps: IDefaultProps = {}

const Header: FunctionComponent<IProps> = ({
  brand,
  timeLeft,
  title,
  description,
}) => {
  const logout = useLogout()

  return (
    <header className='text-left'>
      <div className='flex justify-between items-center'>
        <img className='h-12 w-auto' src={LOGO} alt='Logo' />
        <Menu as='div' className='relative inline-block text-left'>
          <Menu.Button className='cursor-pointer flex items-center'>
            {brand.name && (
              <div className='ml-3 hidden sm:block'>
                <div className='whitespace-nowrap w-36 overflow-hidden text-ellipsis text-sm font-medium text-right text-gray-700 group-hover:text-gray-900'>
                  {brand.name}
                </div>
                <div className='whitespace-nowrap w-36 overflow-hidden text-ellipsis text-xs text-right font-medium text-gray-500 group-hover:text-gray-700'>
                  {brand.email}
                </div>
              </div>
            )}
            <Avatar
              src={brand.logo?.url}
              alt={brand.name}
              size='xs'
              type='brand'
              className='ml-2'
            />
            <div className='ml-2'>
              <Icon type={IconType.chevronUpDown} className='h-4 w-4' />
            </div>
          </Menu.Button>

          <Transition
            as={Fragment}
            enter='transition ease-out duration-100'
            enterFrom='transform opacity-0 scale-95'
            enterTo='transform opacity-100 scale-100'
            leave='transition ease-in duration-75'
            leaveFrom='transform opacity-100 scale-100'
            leaveTo='transform opacity-0 scale-95'
          >
            <Menu.Items
              className={
                'absolute z-10 mt-[-5px] w-[230px] right-2 top-12 origin-top-left divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none'
              }
            >
              <Menu.Item>
                {({ active }) => (
                  <div
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'group flex items-center px-4 py-2 text-sm cursor-pointer',
                    )}
                    onClick={logout}
                  >
                    <Icon
                      type={IconType.logout}
                      className='mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500'
                      aria-hidden='true'
                    />
                    Logout
                  </div>
                )}
              </Menu.Item>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
      <small className='mt-4'>{timeLeft}</small>
      <h2 className='text-gray-900'>{title}</h2>
      {description && (
        <p className='mt-1 text-sm text-gray-500'>{description}</p>
      )}
    </header>
  )
}

Header.defaultProps = defaultProps

export { Header }
